import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

import authService from './auth.service';

class UserService {
  loginUser = (email: string, password: string) => {
    const authenticationData = {
      Username: email.toLowerCase(),
      Password: password,
    };

    const authenticationDetails =
      new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
    const poolData = {
      UserPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      ClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    };

    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username: email.toLowerCase(),
      Pool: userPool,
    };

    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    cognitoUser.setAuthenticationFlowType('USER_PASSWORD_AUTH');
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: async function (result) {
          resolve(result);
        },

        onFailure: function (err) {
          resolve(err);
        },
        newPasswordRequired: async function (userAttributes) {
          delete userAttributes.email_verified;
          resolve({
            message: 'newPasswordRequired',
            userAttributes,
            cognitoUser,
          });
        },
      });
    });
  };

  async signUpUser(
    email: string,
    username: string,
    password: string,
    name: string
  ) {
    const poolData = {
      UserPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      ClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

    const attributeList: any = [];
    const dataEmail = {
      Name: 'email',
      Value: email.toLowerCase(),
    };
    const dataName = {
      Name: 'name',
      Value: name,
    };

    const attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataEmail
    );
    const attributeName = new AmazonCognitoIdentity.CognitoUserAttribute(
      dataName
    );

    attributeList.push(attributeEmail);
    attributeList.push(attributeName);
    return new Promise((resolve, reject) => {
      userPool.signUp(
        username.toLowerCase(),
        password,
        attributeList,
        [],
        async function (err, result) {
          if (err) {
            resolve(err);
          }
          resolve(result);
        }
      );
    });
  }

  async forgotPassword(email: string) {
    const response = await fetch(
      `${process.env.REACT_APP_API_HOST}/internal/users/forgotPassword/`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          email: email,
        }),
      }
    );

    return response.json();
  }

  async confirmPassword(email: string, code: string, password: string) {
    const response = await fetch(
      `${process.env.REACT_APP_API_HOST}/internal/users/confirmPassword/`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          email: email,
          code: code,
          password: password,
        }),
      }
    );

    return response.json();
  }

  newPassword = (email: string, newPassword: string, name: string) => {
    const poolData = {
      UserPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      ClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    };

    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username: email.toLowerCase(),
      Pool: userPool,
    };
    let userAttributes;
    if (email.includes('@')) {
      userAttributes = { email, name };
    } else {
      userAttributes = {
        name,
      };
    }

    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

    const session = localStorage.getItem('session');
    cognitoUser['Session'] = session;
    localStorage.clear();

    return new Promise((resolve, reject) => {
      cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
        onSuccess: async function (response) {
          resolve(response);
        },
        onFailure: function (err) {
          resolve(err);
        },
      });
    });
  };

  async getUserData(): Promise<any> {
    const response = await fetch(`${process.env.REACT_APP_API_HOST}/users`, {
      headers: {
        ...authService.authHeader(),
      },
      method: 'POST',
      body: JSON.stringify({
        query: `{
            getUserData {
                id
                fullName
                email
                docket {
                  ccTango
                }
                permissions
            }
        }`,
      }),
    });
    return response.json();
  }
}

const userService = new UserService();
export default userService;
